import { render, staticRenderFns } from "./ComunicationsModule.vue?vue&type=template&id=15716836"
import script from "./ComunicationsModule.vue?vue&type=script&lang=js"
export * from "./ComunicationsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports